"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["iconText", "title", "subtitle", "icon", "isMobile"];
var HotelFactsItem = function HotelFactsItem(_ref) {
  var _ref$iconText = _ref.iconText,
    iconText = _ref$iconText === void 0 ? '' : _ref$iconText,
    title = _ref.title,
    subtitle = _ref.subtitle,
    icon = _ref.icon,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledHotelFactsItem, (0, _extends2["default"])({
    isMobile: isMobile
  }, props), /*#__PURE__*/_react["default"].createElement(StyledHotelFactsIcon, {
    isMobile: isMobile,
    iconText: iconText
  }, iconText && /*#__PURE__*/_react["default"].createElement("span", null, iconText), icon), /*#__PURE__*/_react["default"].createElement(StyledTexts, null, /*#__PURE__*/_react["default"].createElement(StyledTitle, {
    isMobile: isMobile
  }, title), subtitle ? /*#__PURE__*/_react["default"].createElement(StyledSubtitle, {
    isMobile: isMobile
  }, subtitle) : null));
};
var StyledHotelFactsItem = _styledComponents["default"].div.withConfig({
  displayName: "HotelFactsItem__StyledHotelFactsItem",
  componentId: "sc-xlcsf1-0"
})(["display:flex;align-items:start;padding-bottom:20px;"]);
var StyledTexts = _styledComponents["default"].div.withConfig({
  displayName: "HotelFactsItem__StyledTexts",
  componentId: "sc-xlcsf1-1"
})(["margin-left:10px;padding-right:10px;flex:100%;"]);
var StyledTitle = _styledComponents["default"].h4.withConfig({
  displayName: "HotelFactsItem__StyledTitle",
  componentId: "sc-xlcsf1-2"
})(["", " color:", ";"], function (props) {
  return props.isMobile ? props.theme.typography.mobileHeadline2 : props.theme.typography.headline4;
}, function (props) {
  return props.theme.colors.blackBase;
});
var StyledSubtitle = _styledComponents["default"].span.withConfig({
  displayName: "HotelFactsItem__StyledSubtitle",
  componentId: "sc-xlcsf1-3"
})(["", " color:", ";"], function (props) {
  return props.isMobile ? props.theme.typography.t1s : props.theme.typography.text1;
}, function (props) {
  return props.theme.colors.blackLight;
});
var StyledHotelFactsIcon = _styledComponents["default"].div.withConfig({
  displayName: "HotelFactsItem__StyledHotelFactsIcon",
  componentId: "sc-xlcsf1-4"
})(["display:flex;align-items:center;justify-content:center;flex-shrink:0;border-radius:50%;background-color:", ";width:50px;height:50px;span{padding-bottom:2px;}", " ", ""], function (props) {
  return props.theme.colors.yellowBase;
}, function (props) {
  return props.iconText && "\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    font-size: 14px;\n  ";
}, function (props) {
  return props.isMobile && "\n    width: 40px;\n    height: 40px;\n\n    svg {\n      transform: scale(0.75);\n    }\n\n    span {\n      padding-bottom: 1px;\n    }\n  ";
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelFactsItem);